module.exports = __webpack_public_path__ + "static/algolia-search-9e276445ea762474e6ab62c6e4bfda2b.jpg";